<template>
  <div class="contact">
    <header class="g-header-container">
      <div class="g-navbar">
        <h1 class="g-navbar-title">
          <span class="g-navbar-text">联系我们</span>
        </h1>
        <div class="g-navbar-left">
          <van-icon name="arrow-left" @click="onBack" />
        </div>
      </div>
    </header>
    <main class="g-view-container">
      <div class="talk-container">
        <div class="talk-content">
          <p class="system-remind">
            <span>欢迎您的咨询，期待为您服务！</span>
          </p>
          <message
            v-for="(item, index) in messageList"
            :data="item"
            :key="index"
          />
        </div>
      </div>
    </main>
    <footer class="g-footer-container">
      <div class="input-box">
        <input type="text" v-model="message" />
        <span class="btn-send" @click="sendMessage">发送</span>
      </div>
    </footer>
  </div>
</template>

<script>
  import message from './message';

  export default {
    name: 'contact',
    components: {
      message,
    },
    data() {
      return {
        messageList: [
          {
            type: 'teacher',
            title: '卓考教师',
            content:
              '同学你好，我是卓考网校的老师！<br /><br />现在添加老师微信 zhuokao129<br /><br /> 可以抢领课程免费学以及最新学习课件，学习计划，题库，职业规划等，名额有限，想要领取赶紧联系老师吧。',
            avatarUrl: require('./images/teacher.png'),
          },
        ],
        message: '',
      };
    },
    watch: {
      messageList() {
        setTimeout(() => {
          const ele = this.$el.querySelector('.talk-container');
          ele.scrollTop = ele.scrollHeight;
        }, 500);
      },
    },
    methods: {
      sendMessage() {
        // 发送新消息
        this.messageList.push({
          type: 'customer',
          content: this.message,
          avatarUrl: require('./images/customer.png'),
        });

        // 清空输入框
        this.message = '';

        // 1s后回复
        setTimeout(() => {
          this.messageList.push({
            type: 'teacher',
            title: '卓考教师',
            content: '同学你好，请加老师微信 zhuokao129',
            avatarUrl: require('./images/teacher.png'),
          });
        }, 1000);
      },

      onBack() {
        window.history.back();
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";
.g-navbar {
  background-color: $theme-color;
}

.g-navbar-left {
  font-size: 18px;
  color: #fff;
}

.g-navbar-text {
  color: #fff;
}

.g-view-container {
  padding-bottom: 0;
}

.g-footer-container {
  border-top: 1px solid #eee;
}

.talk-container {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
}

.talk-content {
  position: relative;
  padding: 12px 15px 10px;
}

.system-remind {
  margin-bottom: 15px;
  padding: 0 40px;
  text-align: center;
}

.system-remind span {
  padding: 5px 10px;
  font-size: 12px;
  color: #62778c;
  text-align: center;
  background: #eff3f6;
}

.input-box {
  display: flex;
  font-size: 14px;
}

.input-box > input {
  flex: 1;
  padding: 0 5px;
  color: #333;
}

.btn-send {
  padding: 15px 10px;
  color: #fff;
  background-color: #1e89e6;
}
</style>
